'use client'

import DiscoverySearchForm from '@/components/search/discovery-search-form'

export default function HomepageSearchHeader({
  linkPrefix = 'sim-racing-events',
  ...props
}) {
  return <DiscoverySearchForm {...props} homepage action={`/${linkPrefix}`} />
}
